import React, { Fragment, PureComponent } from 'react';
import AnalysisChart from './analysis-chart';

import { Menu } from 'semantic-ui-react';

const tabOptions = [
  {
    id: 'analysis',
    label: 'Analysis',
  },
];

export default class TabComponentTeacher extends PureComponent {
  constructor() {
    super();
    this.state = {
      activeTabId: 'analysis',
    };
  }

  getComponent = () => {
    const { data } = this.props;
    const { activeTabId } = this.state;
    if (activeTabId === 'analysis') {
      return <AnalysisChart data={data} />;
    }
  };

  handleItemClick = (e, { name }) => {
    this.setState({
      activeTabId: name,
    });
  };

  render() {
    const { activeTabId } = this.state;
    return (
      <Fragment>
        <Menu pointing secondary>
          {tabOptions.map(({ id, label }) => (
            <Menu.Item
              name={id}
              active={activeTabId === id}
              onClick={this.handleItemClick}
            >
              {label}
            </Menu.Item>
          ))}
        </Menu>
        {this.getComponent()}
      </Fragment>
    );
  }
}
